import { UserRole } from "../../../../types/userProfile";

export const DIALOG_BUTTON = {
  SubmitNewString: "SubmitNewString",
  Close: "Close",
} as const;

export type DialogButton = typeof DIALOG_BUTTON[keyof typeof DIALOG_BUTTON];

const BUTTONS_BY_ROLE = {
  [UserRole.ViewOnly]: [DIALOG_BUTTON.Close] as const,
  [UserRole.Contributor]: [DIALOG_BUTTON.SubmitNewString, DIALOG_BUTTON.Close] as const,
  [UserRole.Admin]: [DIALOG_BUTTON.SubmitNewString, DIALOG_BUTTON.Close] as const,
} satisfies Record<UserRole, readonly DialogButton[]>;

export function dialogButtonsForRole(role: UserRole): readonly DialogButton[] {
  return BUTTONS_BY_ROLE[role];
}
